<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card flat tile class="elevation-0 mx-5 offset-holder">
          <div class="">
            <user-list slot="list"></user-list>
          </div>
        </v-card>
      </v-flex>
    </v-layout>
    <user-add v-if="$store.getters.is_unoapp || $store.getters.is_superadmin || $store.getters.is_corporate"></user-add>
    <user-edit-role></user-edit-role>
    <user-profile></user-profile>

    <v-tooltip  slot="action" top>
      <template v-slot:activator="{ on }">
        <v-btn
          v-if="$store.getters.is_unoapp || $store.getters.is_superadmin || $store.getters.is_corporate"
          @click="addModal()"
          v-on="on"
          fixed
          dark
          fab
          bottom
          right
          color="primary"
          depressed
        >
          <v-icon dark v-on="on">add</v-icon>
        </v-btn>
      </template>
      <span>Add New User</span>
    </v-tooltip>

  </v-container>
</template>
<script>
import { mapActions } from 'vuex';
import Env from '@/env';
import AuthApi from '@/components/Controllers/AuthApis';
import userList from './PageComponents/Users/List';
import userAdd from './PageComponents/Users/Add';
import userEditRole from './PageComponents/Users/EditRole';
import userProfile from './PageComponents/Users/UserProfile';
import userDelete from './PageComponents/Users/Delete';

export default {
  components: {
    userList,
    userAdd,
    userEditRole,
    userProfile,
  },
  data() {
    return {
    };
  },
  
  methods: {
    /**
     * Open add new user popup
     */
    addModal() {
      this.addUserPopup(true);
    },
    ...mapActions({
      addUserPopup: 'user/setAdd',
      snackbar: 'snackbar/snackbar',
    }),

  },
};
</script>